import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AnimatePresence, motion } from "framer-motion";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import AllBrokers from "@/pages/AllBrokers";
import BrokerDetail from "@/pages/BrokerDetail";
import NewsList from "@/pages/NewsList";
import NewsDetail from "@/pages/NewsDetail";
import About from "@/pages/About";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/araci-kurumlar" element={<AllBrokers />} />
          <Route path="/kurum/:slug" element={<BrokerDetail />} />
          <Route path="/borsa-haberleri" element={<NewsList />} />
          <Route path="/borsa-haberleri/:id" element={<NewsDetail />} />
          <Route path="/hakkimizda" element={<About />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          <AnimatedRoutes />
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
